/**
 * @flow
 */

import React from 'react'

import {
  ArrowIcon,
  ButtonTextWithIconContainer,
  ButtonText
} from './styledComponents'

class ButtonTextWithIcon extends React.Component<Props> {
  render() {
    const { text, href } = this.props
    return (
      <ButtonTextWithIconContainer href={href} target="_blank">
        <ButtonText dangerouslySetInnerHTML={{ __html: text }} />
        <ArrowIcon />
      </ButtonTextWithIconContainer>
    )
  }
}

export default ButtonTextWithIcon



// WEBPACK FOOTER //
// ./src/components/IbcArcade/ButtonTextWithIcon/index.js